import {Component, OnDestroy, OnInit} from '@angular/core';
import {AccountService, AlertService, UserService} from "../services";
import {ActivatedRoute} from "@angular/router";
import {first} from "rxjs/operators";
import {ServiceService} from "../services/service.service";
import {ComponentTitleService} from "../services/componentTitle.service";

import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {Order} from "../models/order";
import {ReceiptService} from "../services/receipt.service";
import {Receipt} from "../models/receipt";
import {MatDialog} from "@angular/material/dialog";
import {FormGroup} from "@angular/forms";
import {RepeatReceiptPrintingDialogComponent} from "./dialog/repeatReceiptPrintingDialog/repeatReceiptPrintingDialog.component";

@Component({
    templateUrl: './orderDetails.component.html',
    styleUrls: ['./orderDetails.component.scss']
})
export class OrderDetailsComponent implements OnDestroy, OnInit {
    id: string;
    order: Order;
    receipt: Receipt;

    constructor(
        private userService: UserService,
        private alertService: AlertService,
        private accountService: AccountService,
        private route: ActivatedRoute,
        private serviceService: ServiceService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private receiptService: ReceiptService,
        public _matDialog: MatDialog,
    ) {
        componentTitleService.clearTitle();
        componentTitleService.addPart('Orders');

        this.translationLoader.loadTranslations(polish, english);
    }

    ngOnInit() {
        this.id = this.route.snapshot.params['id'];
        this.order = this.route.snapshot.data.order
        this.receiptService.getByOrderUuid(this.order.uuid).pipe(first())
            .subscribe((receipt: Receipt) => {
                this.receipt = receipt;
            });
    }

    ngOnDestroy(): void {

    }

    openRepeatReceiptDialog(): void {
        let dialogRef = this._matDialog.open(RepeatReceiptPrintingDialogComponent, {
            panelClass: 'repeat-receipt-printing-dialog',
            data      : {
                action : 'show',
                order: this.order,
            },
            width: '350px',
        });

        dialogRef.afterClosed()
            .subscribe((response: any) => {
                if (!response) {
                    return;
                }

                if (response === 'confirm') {
                    this.receiptService.repeatPrinting(this.order.uuid).subscribe(res => {

                    }, err => {
                        console.log(err);
                    });
                }

            }, (err) => {
                console.log(err);
            });
    }
}
